import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vue3TouchEvents from 'vue3-touch-events';
import VueGtag from 'vue-gtag';
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import { PROD_DOMAINS } from './constants.js'

const app = createApp({
  extends: App,
  created: () => { 
    setSiteConfig();
    // redirect to www if appropriate
    redirectToWww();
    store.dispatch('fetchTranslation');   
  },
  maxEvents: 20 
});
try {
  Bugsnag.start({
    apiKey: 'de5b32de93f8b5dbb496847fdca85914',
    plugins: [new BugsnagPluginVue()],
    releaseStage: process.env.NODE_ENV || 'unset'
  });

  const bugsnagVue = Bugsnag.getPlugin('vue');
  app.use(bugsnagVue)
} catch (error) {
  console.error('Error initializing Bugsnag:', error);
}

app.use(VueGtag, {
  config: { id: process.env.NODE_ENV === 'production' ? '345016228' : '' }, //Property ID for Analytics. DO NOT use the measurement ID.
});

window.power = 1.4;
app.use(Vue3TouchEvents)
app.config.productionTip = false
app.use(store)
app.use(router)
app.mount('#app');

console.log('Made with ❤️ by Reality Interactive %cri',
            'color:white;background:rgb(250, 11, 11);padding:4px 4px 3px 3px;font-family:serif;font-size:14px;line-height:16px;');
if (process.env.NODE_ENV !== 'production') console.log('build environment is ' + process.env.NODE_ENV);


// Eruda debugging - add ?eruda=true
;(function () {
    var src = '//cdn.jsdelivr.net/npm/eruda';
    if (!/eruda=true/.test(window.location) && localStorage.getItem('active-eruda') != 'true') return;
    document.write('<scr' + 'ipt src="' + src + '"></scr' + 'ipt>');
    document.write('<scr' + 'ipt>eruda.init();</scr' + 'ipt>');
})();

// if production build, and hosted at one of the known hosts, force www.
function redirectToWww() {
  // for production builds
  if (process.env.NODE_ENV === 'production') {
    // if hostname does not include www. 
    if (!window.location.hostname.toLowerCase().includes('www.')) {
      // check if site config matches by hostname
      const siteConfig = PROD_DOMAINS.find(x => {
        // compare hostname app served from, disregarding www.
        return x.domain.replace('www.', '') === window.location.hostname.toLowerCase().replace('www.', '')
      });

      // if app being served from one of the prod domains
      if (siteConfig) {
        const domainWithoutWww = siteConfig.domain.replace('www.', '')
        /* 
          check if the production domain originally 
          had "www." in it, to avoid infinite redirects.
        */
        if (siteConfig.domain !== domainWithoutWww) {
          // check site configuration
          if (siteConfig.redirectWww) {
            // redirect to www
            window.location.replace(window.location.href.replace(domainWithoutWww, siteConfig.domain));
          }
        }
      }
    }
  } 
}
// determine "site configuration" based on hostname that app was served from
function setSiteConfig() {
  const url = new URL(window.location.href)
  // allow override by URL parameter for dev and testing purposes
  let hostname = url.hostname
  if (url.searchParams && url.searchParams.has('siteconfig')) {
    hostname = url.searchParams.get('siteconfig')
  }
  // find in array of site configurations
  const siteConfig = PROD_DOMAINS.find(x => {
    // compare hostname app served from, disregarding www.
    return x.domain.replace('www.', '') === hostname.toLowerCase().replace('www.', '')
  });
  if (siteConfig) {
    store.commit('setSiteConfiguration', siteConfig)
    store.commit('setLangCode', siteConfig.locale)
  } else {
    console.log('site configuration not identified. url.hostname is ' + url.hostname)
  }
}